declare global {
  interface Window {
    __HOME_LOVIN_ENV__?: Record<string, string>;
  }
}

function value(name: string) {
  return window.__HOME_LOVIN_ENV__?.[name] || import.meta.env[`VITE_${name}`] || "";
}

export const runtime = {
  appEnv: value("APP_ENV") || "local",
  appBaseUrl: value("APP_BASE_URL"),
  supabaseUrl: value("SUPABASE_URL"),
  supabaseAnonKey: value("SUPABASE_ANON_KEY") || value("SUPABASE_PUBLISHABLE_KEY"),
  requireAuth: ["1", "true", "yes"].includes((value("REQUIRE_AUTH") || "").toLowerCase())
};

export function isSupabaseConfigured() {
  return Boolean(runtime.supabaseUrl && runtime.supabaseAnonKey && !runtime.supabaseUrl.includes("YOUR_"));
}

export function oauthRedirectUrl() {
  const configured = runtime.appBaseUrl.replace(/\/+$/, "");
  const current = window.location.origin;
  const local = /^(https?:\/\/)?(localhost|127\.0\.0\.1|\[::1\])(?::\d+)?/i;
  const base = configured && !(local.test(configured) && !local.test(current)) ? configured : current;
  return `${base}/`;
}
